<div class="company-shipping-addresses">
  <div class="flex justify-content-end mb-4">
    <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
      Actions <i class="flaticon-more ml-2"></i>
    </button>
    <mat-menu class="lum-mat-menu" #menu="matMenu">
      <button mat-menu-item (click)="onCreateShippingAddress()">
        Create Shipping Address
      </button>
    </mat-menu>
  </div>

  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    style="width: 100%"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
